import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin, Send } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = '/images/kosad-logo.png';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/api/newsletter`, { email });
      setSubscribed(true);
      setEmail('');
      setError('');
    } catch (err) {
      setError('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  return (
    <footer className="bg-[#1A3625] text-white" data-testid="main-footer">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="container-custom py-16">
          <div className="max-w-2xl mx-auto text-center">
            <span className="label-uppercase text-[#D4AF37] mb-4 block">Bültenimize Abone Olun</span>
            <h3 className="text-2xl md:text-3xl font-medium mb-4">
              Doğadan Haberler Alın
            </h3>
            <p className="text-white/70 text-base mb-8">
              Projelerimiz, etkinliklerimiz ve yeni ürünlerimiz hakkında bilgi alın.
            </p>
            
            {subscribed ? (
              <div className="bg-[#D4AF37]/20 rounded-full py-4 px-8 inline-block" data-testid="newsletter-success">
                <p className="text-[#D4AF37] font-medium">Teşekkürler! Bültenimize kaydoldunuz.</p>
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  className="flex-1 px-6 py-4 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 focus:outline-none focus:border-[#D4AF37]"
                  required
                  data-testid="newsletter-email-input"
                />
                <button
                  type="submit"
                  className="btn-gold flex items-center justify-center gap-2"
                  data-testid="newsletter-submit-button"
                >
                  <Send className="w-4 h-4" />
                  Abone Ol
                </button>
              </form>
            )}
            {error && <p className="text-red-400 mt-4">{error}</p>}
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src={LOGO_URL} alt="KOSAD" className="h-14 mb-6 brightness-0 invert" />
            <p className="text-white/70 mb-6">
              Kocaeli Sürdürülebilir Arıcılık ve Dayanışma Derneği olarak, 
              arıların ve doğanın korunması için çalışıyoruz.
            </p>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#D4AF37] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#D4AF37] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#D4AF37] transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-white/10 rounded-full hover:bg-[#D4AF37] transition-colors" aria-label="Youtube">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-medium mb-6">Hızlı Bağlantılar</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/hakkimizda" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/calismalarimiz" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Projelerimiz
                </Link>
              </li>
              <li>
                <Link to="/egitim" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Eğitim
                </Link>
              </li>
              <li>
                <Link to="/haberler" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Haberler
                </Link>
              </li>
              <li>
                <Link to="/market" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Market
                </Link>
              </li>
              <li>
                <Link to="/katil" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Bize Katılın
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-base font-medium mb-6">Yasal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/yasal/gizlilik" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <Link to="/yasal/cerezler" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Çerez Politikası
                </Link>
              </li>
              <li>
                <Link to="/yasal/kullanim" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  Kullanım Koşulları
                </Link>
              </li>
              <li>
                <Link to="/yasal/kvkk" className="text-white/70 hover:text-[#D4AF37] transition-colors">
                  KVKK Aydınlatma
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base font-medium mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-1" />
                <span className="text-white/70">
                  Örnek Mahallesi, Doğa Sokak No: 12<br />
                  Kocaeli, Türkiye
                </span>
              </li>
              <li>
                <a href="tel:+902621234567" className="flex items-center gap-3 text-white/70 hover:text-[#D4AF37] transition-colors">
                  <Phone className="w-5 h-5 text-[#D4AF37]" />
                  +90 262 123 45 67
                </a>
              </li>
              <li>
                <a href="mailto:info@kosad.org" className="flex items-center gap-3 text-white/70 hover:text-[#D4AF37] transition-colors">
                  <Mail className="w-5 h-5 text-[#D4AF37]" />
                  info@kosad.org
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2026 KOSAD. Tüm hakları saklıdır.
            </p>
            <p className="text-white/50 text-sm">
              Arılar için, doğa için, gelecek için.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
;
